<template>
  <div class="shadow-sm border-gray-300 border block w-full rounded-md">
    <div class="my-4">
      <div class="ui-editor-content" :id="holder"/>
    </div>
  </div>
</template>

<script>
import i18n from "@/components/ui/form/editor/i18n";

import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import Paragraph from "@editorjs/paragraph";
import List from "@editorjs/list";

import AttachesTool from "./plugins/attaches";
import Marker from './plugins/marker'
import Delimiter from './plugins/delimiter'
import Warning from './plugins/warning'
import Table from '@editorjs/table';

import './index.scss'

const all_tools = {
  paragraph: {
    class: Paragraph,
    config: {
      placeholder: "введите текст..."
    }
  },
  header: {
    class: Header,
    config: {
      placeholder: 'Введите заголовок',
      levels: [2, 3, 4],
      defaultLevel: 3
    },
    shortcut: "CMD+SHIFT+H"
  },
  list: {
    class: List
  },

  marker: {
    class: Marker,
    shortcut: 'CMD+SHIFT+M',
  },
  delimiter: {
    class: Delimiter,
    shortcut: 'CMD+SHIFT+M',
  },
  attaches: {
    class: AttachesTool,
    config: {
      endpoint: window.location.href
    }
  },
  warning: {
    class: Warning,
    inlineToolbar: true,
    shortcut: 'CMD+SHIFT+W',
    config: {
      messagePlaceholder: 'Текст сообщения',
    },
  },
  table: Table,
}

import {setup as baseSetup, mixin} from "@/components/ui/form/mixins/BaseInput";
import {watch, ref, onMounted} from "vue";
import {isObject} from "lodash";

export default {
  mixins: [mixin],
  props: {
    holder: {
      default: 'holder',
      type: String
    },
    tools: {
      type: Array,
      default: () => ['header', 'list', 'paragraph']
    },
    modelValue: {}
  },
  setup(props) {
    const base_config = baseSetup(props)
    const saved_at = ref(0)
    const tools = {}

    props.tools.forEach(tool=>{
      if (isObject(tool)){
        const key = tool.name
        delete tool.name
        tools[key] = all_tools[key]
        Object.assign(tools[key], tool);
      } else {
        tools[tool] = all_tools[tool]
      }
    })


    let editor_config = {
      holder: props.holder,
      //autofocus: true,

      tools: tools,
      onReady: function () {
        //console.log("ready");
      },
      onChange: function () {
        editor.value.save().then(savedData => {
          base_config.input(savedData)
          saved_at.value = savedData.time
        })
      },
      data: null,
      i18n: i18n,
      initialBlock: "paragraph",
    }

    const editor = ref(new EditorJS(editor_config));

    watch(() => props.modelValue, async () => {
      if (props.modelValue && 'blocks' in props.modelValue) {
        if (saved_at.value !== props.modelValue.time) {
          await editor.value.isReady
          editor.value.clear()
          await editor.value.render(props.modelValue)
        }
      }
    })

    onMounted(async () => {
      if (props.modelValue) {
        await editor.value.isReady
        editor.value.clear()
        await editor.value.render(props.modelValue)
      }
    })

    return {...base_config, editor, saved_at}
  },

};
</script>

